import type {
  FeatureFlag,
  FeatureFlagCategory,
  FeatureFlagRow,
  FeatureFlagValueType,
} from '../types';

/**
 * Mapper for converting feature flag database rows to entities
 */
export class FeatureFlagMapper {
  /**
   * Convert database row to entity
   */
  static toEntity(row: FeatureFlagRow): FeatureFlag {
    return {
      id: row.id,
      key: row.key,
      valueType: row.value_type as FeatureFlagValueType,
      boolValue: row.bool_value,
      stringValue: row.string_value,
      description: row.description,
      category: row.category as FeatureFlagCategory | null,
      isActive: row.is_active ?? true,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    };
  }
}
